<div class="modal-header">
    <h4 class="modal-title float-left">{{title}}</h4>
    <button type="button" class="close float-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{content}}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Close</button>
</div>
